import styled from 'styled-components';

export interface ICardContainer {
  isListView?: boolean;
}

const CardContainer = styled.div<ICardContainer>`
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  overflow-x: ${p => (p.isListView ? 'visible' : 'auto')};
  background-color: ${Styles.color.grey.five};
  padding: ${p => (p.isListView ? `0.5rem 1rem 0` : 'inherit')};

  ${Styles.desktop`
    padding: 0.5rem 1rem 0;
    height: auto;
    overflow-x: visible;
  `}

  ${Styles.mobile`
    min-height: 12.375rem;
  `}

  ${Styles.mobileFullscreen`
    padding-bottom: env(safe-area-inset-bottom);
  `}
`;

export default CardContainer;
